/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type GeneralConnectType from '@jira/spa-apps__jira-connect-general-pages/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyGeneralConnect: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof GeneralConnectType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-connect", jiraSpaEntry: "async-connect" */ '@jira/spa-apps__jira-connect-general-pages/src/index.tsx'
			),
		),
	);

const AsyncGeneralConnect = (): React.JSX.Element => (
	<LazyPage Page={LazyGeneralConnect} pageId="connect" shouldShowSpinner />
);

export default AsyncGeneralConnect;
